let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c7XPr")).then(() => parcelRequire('5rAOr'));